import Global from "@/scripts/Global"
import SessionManager from "@/Manager/Session.manager";
import LicenseApi from "@/scripts/api/license.api";
import ChannelNotification from "@/Manager/Notification/Channel.manager";
import VueSignals from "@/scripts/VueSignals";


export default {
    name: 'RemoveLicense',
    data() {
        return {
            currData: {
                'cust_order_cp_id': '',
                'license_name': ''
            },
            confirmCheck: false,
            ActiveChannelDoc: SessionManager.getActiveChannel()
        }
    },
    mounted() {
        this.currData = this.$parent.data
    },
    methods: {
        RemoveLicense() {
            if (this.confirmCheck) {
                LicenseApi.UnAssign(this.currData.cust_order_cp_id).then(res => {
                    if (res.data.result) {
                        ChannelNotification.RemoveLicense(this.ActiveChannelDoc.channel_id,
                            this.currData.cust_order_cp_id,
                            this.ActiveChannelDoc.user_ids)
                        Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
                    }
                })
            }
        }
    }
}
